import React from 'react'
import PropTypes from 'prop-types'
import './Field.scss'
import FieldInput from './FieldInput'

const getCheckedClassName = checked =>
  `has-checkbox ${checked ? 'checked' : 'unchecked'}`

const Field = ({
  label,
  theme,
  info,
  placeholder,
  active,
  icon,
  handleClick,
  hasCheckbox,
  handleCheckboxClick,
  isChecked,
  disabled,
  autoComplete,
  handleType,
  handleOnKeyDown,
  handleOnFocus,
  value,
  handleOnBlur,
}) => {
  const buttonClass = 'Field__button'
  const iconClass = icon ? `-has-icon icon icon-${icon}` : ''
  const activeClass = active ? '-open' : ''
  const themeClass = theme ? `-${theme}` : ''
  const buttonClassList = `${buttonClass} ${activeClass} ${themeClass} ${iconClass}`
  const isCalendar = icon === 'calendar'
  return (
    <div>
      <label
        className={`Field__label ${
          hasCheckbox ? getCheckedClassName(isChecked) : ''
        }`}
        {...hasCheckbox && { onClick: handleCheckboxClick }}
      >
        <span className="label--bold--bp0">{label}</span>
      </label>
      {info && (
        <p className="Field__description" key="info">
          {info}
        </p>
      )}
      {autoComplete ? (
        <FieldInput
          isCalendar={isCalendar}
          handleClick={handleClick}
          handleType={handleType}
          handleOnKeyDown={handleOnKeyDown}
          handleOnFocus={handleOnFocus}
          handleOnBlur={handleOnBlur}
          value={value}
          disabled={disabled}
          placeholder={placeholder}
          buttonClass={buttonClass}
          buttonClassList={buttonClassList}
          iconClass={iconClass}
        />
      ) : (
        <span
          tabIndex="0"
          onFocus={handleOnFocus}
          className={buttonClassList}
          onClick={handleClick}
          onKeyDown={handleOnKeyDown}
          disabled={disabled}
        >
          {value || placeholder}
        </span>
      )}
    </div>
  )
}

Field.propTypes = {
  label: PropTypes.string,
  theme: PropTypes.string,
  info: PropTypes.string,
  placeholder: PropTypes.string,
  active: PropTypes.bool,
  icon: PropTypes.string,
  handleClick: PropTypes.func,
  value: PropTypes.string,
  hasCheckbox: PropTypes.bool,
  handleCheckboxClick: PropTypes.func,
  isChecked: PropTypes.bool,
  disabled: PropTypes.bool,
  autoComplete: PropTypes.bool,
  handleType: PropTypes.func,
  handleOnKeyDown: PropTypes.func,
  handleOnFocus: PropTypes.func,
  handleOnBlur: PropTypes.func,
}

export default Field
